export default __webpack_public_path__ + "static/media/student-img.7a60bba2.svg";